module.exports = __webpack_public_path__ + "static/media/md-journal.e4ba680c.svg";